module.exports = __webpack_public_path__ + "img/bg-head.20f794fb.png";